"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _FaqLayout = require("./FaqLayout");
Object.keys(_FaqLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FaqLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FaqLayout[key];
        }
    });
});
var _FourMediaLayout = require("./FourMediaLayout");
Object.keys(_FourMediaLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FourMediaLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FourMediaLayout[key];
        }
    });
});
var _standalone = require("./standalone");
Object.keys(_standalone).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _standalone[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _standalone[key];
        }
    });
});
var _shared = require("./shared");
Object.keys(_shared).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _shared[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _shared[key];
        }
    });
});
var _QuoteLayout = require("./QuoteLayout");
Object.keys(_QuoteLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _QuoteLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _QuoteLayout[key];
        }
    });
});
var _TestimonialsLayout = require("./TestimonialsLayout");
Object.keys(_TestimonialsLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TestimonialsLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TestimonialsLayout[key];
        }
    });
});
var _ThreeMediaRightBottomTextLayout = require("./ThreeMediaRightBottomTextLayout");
Object.keys(_ThreeMediaRightBottomTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ThreeMediaRightBottomTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ThreeMediaRightBottomTextLayout[key];
        }
    });
});
var _TwoMediaLayout = require("./TwoMediaLayout");
Object.keys(_TwoMediaLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TwoMediaLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TwoMediaLayout[key];
        }
    });
});
var _TwoMediaRightTopTextLayout = require("./TwoMediaRightTopTextLayout");
Object.keys(_TwoMediaRightTopTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TwoMediaRightTopTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TwoMediaRightTopTextLayout[key];
        }
    });
});
var _OneMediaCenterBottomTextLayout = require("./OneMediaCenterBottomTextLayout");
Object.keys(_OneMediaCenterBottomTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OneMediaCenterBottomTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _OneMediaCenterBottomTextLayout[key];
        }
    });
});
var _ParagraphTextLayout = require("./ParagraphTextLayout");
Object.keys(_ParagraphTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ParagraphTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ParagraphTextLayout[key];
        }
    });
});
var _EditorialInfo = require("./EditorialInfo");
Object.keys(_EditorialInfo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _EditorialInfo[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _EditorialInfo[key];
        }
    });
});
var _HeadlineLayout = require("./HeadlineLayout");
Object.keys(_HeadlineLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _HeadlineLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _HeadlineLayout[key];
        }
    });
});
var _OneMediaOverlayTextLayout = require("./OneMediaOverlayTextLayout");
Object.keys(_OneMediaOverlayTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OneMediaOverlayTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _OneMediaOverlayTextLayout[key];
        }
    });
});
var _VerticalVideoLayout = require("./VerticalVideoLayout");
Object.keys(_VerticalVideoLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _VerticalVideoLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _VerticalVideoLayout[key];
        }
    });
});
var _FiftyFiftyLayout = require("./FiftyFiftyLayout");
Object.keys(_FiftyFiftyLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FiftyFiftyLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _FiftyFiftyLayout[key];
        }
    });
});
var _LinkListLayout = require("./LinkListLayout");
Object.keys(_LinkListLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _LinkListLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _LinkListLayout[key];
        }
    });
});
var _BenefitsLayout = require("./BenefitsLayout");
Object.keys(_BenefitsLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _BenefitsLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _BenefitsLayout[key];
        }
    });
});
var _CtaButtonLayout = require("./CtaButtonLayout");
Object.keys(_CtaButtonLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CtaButtonLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _CtaButtonLayout[key];
        }
    });
});
var _LinksCarouselLayout = require("./LinksCarouselLayout");
Object.keys(_LinksCarouselLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _LinksCarouselLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _LinksCarouselLayout[key];
        }
    });
});
